// Приоритет проекта P1..P10 (P1 — самый высокий). Три ступени подсветки на
// существующих токенах: P1–P3 — danger (красная зона), P4–P6 — warning
// (янтарная), P7–P10 — нейтральная.
export function priorityTone(priority: number): string {
  if (priority <= 3) return 'text-overdue'
  if (priority <= 6) return 'text-warning'
  return 'text-text-secondary'
}
